import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";

export const AnimateIn = ({
  className = "",
  children,
  animation = "zoom-out-up",
  delay = 250,
  duration = 500,
  once = true,
  easing = "ease-in-sine",
  ...props
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      AOS.init({ disable: () => window.innerWidth < 992 });
    }
  }, [mounted]);

  const animationProps = mounted
    ? {
        "data-aos": animation,
        "data-aos-delay": delay,
        "data-aos-duration": duration,
        "data-aos-once": once,
        "data-aos-easing": easing,
      }
    : {};

  return (
    <div className={className} {...animationProps} {...props}>
      {children}
    </div>
  );
};
